export default __webpack_public_path__ + "static/media/field-cricket.a6910640.png";